import {Component, HostListener, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material';
import {TranslateService} from '@ngx-translate/core';
import {FormGroup} from '@angular/forms';
import {LangChange} from '../../../../../lang-change';
import {Utils} from '../../../../../common/services/Utils';
import {Language} from '../../../../../common/models/language';
import {Principal} from '../../../../../common/services/principal';
import {TechSupportService} from '../../../../shared/services/tech-support.service';
import {TechFaq} from '../tech-faq';

@Component({
  selector: 'app-tech-support-faq-modal',
  templateUrl: './tech-support-faq-modal.component.html',
  styleUrls: ['./tech-support-faq-modal.component.scss']
})
export class TechSupportFaqModalComponent extends LangChange implements OnInit {

  editForm: FormGroup;
  moduleSettings: any;
  forms: any[];
  objProps;
  langId: number;
  faqId: number;
  isViewMode: boolean;
  faq: TechFaq;

  constructor(public dialogRef: MatDialogRef<TechSupportFaqModalComponent>,
              @Inject(MAT_DIALOG_DATA) public data: any,
              private utils: Utils,
              private principal: Principal,
              private translateService: TranslateService,
              private techService: TechSupportService) {
    super(translateService);
  }

  ngOnInit() {
    this.faq = new TechFaq();
    this.faqId = this.data.faqId;
    this.langId = Language.getCurrentLanguage().id;
    this.getData();
  }

  getData() {
    if (this.faqId) {
      this.utils.blockStart(null);
      this.techService.getModeratorFAQById(this.faqId).subscribe(data => {
        if (data) {
          this.faq = data;
        }
        this.utils.blockStop();
      });
    }
  }

  @HostListener('keydown.esc')
  public onEsc() {
    this.dialogRef.close();
  }

  onLangChange(langCode): void {
    this.langId = langCode.id;
  }

  onSubmit() {
    // if (!this.appId) {
    //   this.appId = 0;
    // }
    // this.settlingInfo.type = this.data.type;
    this.techService.saveModeratorFAQ(this.faq).subscribe(
      (data) => {
        if (data.status === 'SUCCESS') {
          this.utils.notifySuccess(this.translateService.instant('saved'), null);
          this.dialogRef.close('ok');
        } else {
          this.utils.notifyError(this.translateService.instant('err_try_again_later'), null);
        }
      },
      error => {
        this.utils.notifyError(this.translateService.instant('err_try_again_later'), null);
      }
    );
  }

  close(): void {
    this.dialogRef.close();
  }

}



// WEBPACK FOOTER //
// ./src/app/modules/common-main/components/tech-support/faq-modal/tech-support-faq-modal.component.ts